//import { useGrid } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import {
  PartnerGroupItem,
  getPartnerGroupService,
} from "./partnerGroupApi";

export default function usePartnerGroupList() {
  const params = useParams();
  const scope = undefined;
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "partner-groups/"
      : ""
  }`
  const service = getPartnerGroupService();

  return { ...service, params, scope, editUrl };
}

